export default (): BookingInsightsState => ({
  bookingsCopy: null,
  bookingsMap: null,
  bookingsReviews: null,
  currentBookingQuote: null,
  loading: false,
  error: null,
  postalCode: null
})
